import { useState } from 'react';
import images from './api/images.js';
import Slide from './Slide';
import BtnsSlideAlert from './BtnsSlideAlert';
import Breadcrumbs from './Breadcrumbs';
import './Carousel.css';

export default function Carousel() {
  const [imageNum, setImageNum] = useState(0);
  const [isCarouselActive, setIsCarouselActive] = useState(false);
  const [isPrevNextBtnClick, setIsPrevNextBtnClick] = useState(false);

  const handlePrev = () => {
    setImageNum((prev) => Math.max(prev - 1, 0));
    setIsCarouselActive(true);
    setIsPrevNextBtnClick(true);
  };

  const handleNext = () => {
    setImageNum((prev) => Math.min(prev + 1, images.length - 1));
    setIsCarouselActive(true);
    setIsPrevNextBtnClick(true);
  };

  const handlePagination = (num) => {
    setImageNum(num - 1);
    setIsCarouselActive(true);
    setIsPrevNextBtnClick(false);
  };

  return (
    <div className="carousel">
      <Slide image={images[imageNum]} />
      <BtnsSlideAlert
        imageNum={imageNum}
        images={images}
        isCarouselActive={isCarouselActive}
        isPrevNextBtnClick={isPrevNextBtnClick}
        handlePrev={handlePrev}
        handleNext={handleNext}
      />
      <Breadcrumbs
        images={images}
        imageNum={imageNum}
        handlePagination={handlePagination}
      />
    </div>
  );
}
